<template>
  <div class="audio-control" v-if="$store.state.slide.audioLink">
    <audio
      :src="$store.state.slide.audioLink.url"
      controls
      preload="auto"
      :autoplay="$store.state.slide.audioAudienceAutoPlay"
      :loop="$store.state.slide.audioAudienceRepeat"
      ref="audio-slide-tag"
    />
    <div @click="playAudio()" class="mt-2 mb-2 play-audio" v-if="showAutoPlayWarning">
      <i class="fas fa-play animate__animated animate__flash" /> {{ $t('playAudioNow') }}
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      showAutoPlayWarning: false,
    }
  },
  watch: {
    '$store.state.slide.audioAudienceAutoPlay': function (audioAutoPlay) {
      if (audioAutoPlay && this.$store.state.slide.audioPlayOnAudience) {
        this.$refs['audio-slide-tag'].play()
      }
    },
  },
  mounted() {
    if (this.$store.state.slide.audioAudienceAutoPlay && this.$store.state.slide.audioPlayOnAudience) {
      const promise = this.$refs['audio-slide-tag'].play()
      if (promise !== undefined) {
        promise.then(() => {
          this.showAutoPlayWarning = false
          // Autoplay started!
        }).catch(() => {
          // Show something in the UI that the video is muted
          this.$store.state.slide.audioAudienceShowControl = true
          this.showAutoPlayWarning = true
        })
      }
    }
  },
  methods: {
    playAudio() {
      this.$refs['audio-slide-tag'].play()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.play-audio {
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}
</style>
